import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { lazy } from 'react'

const Inner = lazy(() => import('./Inner'))

/**
 * Container component for Terms of Use acceptance dialog that ensures we only render
 * the dialog when the module has been requested to load.
 */
export const TermsOfUseAcceptanceDialogContainer = observer(
  function TermsOfUseAcceptanceDialogContainer() {
    const { isRequested } = useFeatures((app) => ({
      isRequested: app.account.internal.isRequested,
    }))

    if (!isRequested()) {
      return null
    }

    return <Inner />
  },
)
